module.exports = __webpack_public_path__ + "static/media/TAKE UP BOWL (591-02500 ) FOR SDS 900-1200 MACHINES..71b9f704.jpg";